import { useFinancingListContext } from './Context';

const useFinancingListViewModel = () => {
  const { financingList, fetchFinancingList, financingListPageable } = useFinancingListContext();

  return { financingList, fetchFinancingList, financingListPageable };
};

export default useFinancingListViewModel;
